import React from 'react';
import PropTypes from 'prop-types';
import { datetime } from '@common/services/datetime';
import {
  DocumentPreviewModalDeprecated,
  resolveByUrl,
  Icon,
  Col,
  Row,
} from '@common/components';
import { Colors, LineHeight } from '@common/tokens';

function getFormattedDate(dateValue) {
  return datetime(dateValue).format('h:mmA, M/D/YYYY');
}

export function SubmittalPacketsPreviewModalLink({ submittalPacket }) {
  const file = submittalPacket?.files[submittalPacket?.files.length - 1];

  return (
    <>
      <DocumentPreviewModalDeprecated
        title={file?.filename}
        trigger={
          <Row>
            <Col span={1} className="center">
              <Icon icon="copy" kind="regular" size="md" color="elm" />
            </Col>
            <Col span={23}>
              <Row>
                <a className="submittal-packet-filename">{file?.filename}</a>
              </Row>
              <Row>
                <span className="submittal-packet-details">
                  uploaded {getFormattedDate(file?.createdAt)}
                </span>
              </Row>
            </Col>
          </Row>
        }
        assets={[file?.downloadUrl].filter((d) => d)}
        resolveAsset={resolveByUrl}
      />
      <style jsx>{`
        :global(.center) {
          display: flex;
          align-items: center;
        }
        .submittal-packet-filename {
          color: ${Colors.elm};
          font-weight: 800;
          line-height: ${LineHeight.xs};
        }
        .submittal-packet-details {
          color: ${Colors.midnightLighter};
          font-size: 13px;
          font-weight: 800;
          line-height: 14px;
        }
      `}</style>
    </>
  );
}

SubmittalPacketsPreviewModalLink.propTypes = {
  submittalPacket: PropTypes.shape({
    id: PropTypes.string,
    files: PropTypes.arrayOf(
      PropTypes.shape({
        filename: PropTypes.string,
        downloadUrl: PropTypes.string,
        createdAt: PropTypes.string,
      })
    ),
  }),
};
